/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-static-element-interactions,jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UserService from 'mt-react-common/modules/users/services/UserService';
import { useLightForm } from 'utils/hooks/useLightForm';
import { selectEmail } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { logout } from 'utils/authHelper';
import { t } from 'utils/translates';

const ChangePasswordApproveModal = props => {
  const { isOpen, onClose } = props;
  const authAccountEmail = useSelector(state => selectEmail(state));
  const modalId = `changePasswordApproveModal`;
  const approveChangePasswordForm = useLightForm({
    code_approve: null
  });

  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#${modalId}`).modal(isOpen ? 'show' : 'hide');
  }, [isOpen]);

  const fetchChangePasswordApprove = () => {
    approveChangePasswordForm.setLoading(true);
    UserService.changePasswordApprove(approveChangePasswordForm.fields).then(
      responseModel => {
        // console.log(responseModel);
        if (responseModel && responseModel.status === 200) {
          console.log(responseModel);
          logout();
        } else if (responseModel && responseModel.status === 422) {
          approveChangePasswordForm.setErrors(responseModel.data);
        }
        approveChangePasswordForm.setLoading(false);
      }
    );
  };

  const errorDesc = fieldName => {
    const errorMessage = approveChangePasswordForm.getFirstFieldError(
      fieldName
    );
    if (errorMessage) {
      return <small className="help-block">{errorMessage}</small>;
    }
    return null;
  };

  return (
    <div
      className="modal fade task-change-status-manage-modal"
      id={modalId}
      role="dialog"
      tabIndex="-1"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-gray"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              aria-label="Close"
              className="close close-black"
              href={null}
              onClick={onClose}
            />
            <i className="fa fa-check-circle-o modal-icon" />
            <h4 className="modal-title">
              <strong>{t(`Подтверждение действия`)}</strong>
            </h4>
          </div>
          <div className="modal-body">
            <div className="panel-body">
              <p className="text-center">
                {t(
                  'На вашу почту {email} отправлено письмо с кодом подтверждения. <br /> Откройте ваш почтовый клиент или новую вкладку с почтовым сервисом, скопируйте код и вставьте в форму ниже:',
                  { email: authAccountEmail }
                )}
              </p>
              <div
                className={classNames('form-group', {
                  'has-error': approveChangePasswordForm.hasFieldError(
                    'code_approve'
                  )
                })}
              >
                <label className="control-label" htmlFor="approveCode">
                  {t('Код подтверждения')}
                </label>
                <input
                  className="form-control ng-untouched ng-pristine ng-invalid"
                  id="approveCode"
                  minLength="6"
                  name="approveCode"
                  placeholder={t('Код подтверждения')}
                  required=""
                  value={approveChangePasswordForm.getFieldValue(
                    'code_approve'
                  )}
                  onChange={e => {
                    approveChangePasswordForm.setFieldValue(
                      'code_approve',
                      e.target.value
                    );
                  }}
                />
                {errorDesc('code_approve')}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <a
              className="btn btn-muted"
              data-dismiss="modal"
              href=""
              type="button"
              onClick={onClose}
            >
              {t('Отмена')}
            </a>
            <a
              className={classNames('btn btn-success', {
                disabled: approveChangePasswordForm.isLoading
              })}
              href=""
              type="button"
              onClick={e => {
                e.preventDefault();
                fetchChangePasswordApprove();
              }}
            >
              {t('Применить')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

ChangePasswordApproveModal.defaultProps = {
  isOpen: false,
  onClose: () => {}
};

ChangePasswordApproveModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default ChangePasswordApproveModal;



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserChangePasswordForm/ChangePasswordApproveModal/index.js